<template>
  <layout title="Templates">
    <main class="relative z-0 flex-1 overflow-y-auto focus:outline-none" tabindex="0">
      <!-- Page title & actions -->
      <div class="px-4 py-4 border-b border-gray-200 sm:flex sm:items-center sm:justify-between sm:px-6 lg:px-8">
        <div class="flex-1 min-w-0">
          <h1 class="text-lg font-medium leading-6 text-gray-900 sm:truncate">
            Templates
          </h1>
        </div>
        <div class="flex mt-4 sm:mt-0 sm:ml-4">
          <span class="rounded-md shadow-sm order-0 sm:order-1 sm:ml-3">
            <button
              type="button"
              @click="createTemplate"
              class="inline-flex items-center px-4 py-2 text-sm font-medium leading-5 text-white transition duration-150 ease-in-out bg-green-600 border border-transparent rounded-md hover:bg-green-500 focus:outline-none focus:shadow-outline-green focus:border-green-700 active:bg-green-700">
              Template toevoegen
            </button>
          </span>
        </div>
      </div>

      <!-- Projects table (small breakpoint and up) -->
      <div class="hidden sm:block">
        <div class="inline-block min-w-full align-middle border-b border-gray-200">
          <table class="min-w-full">
            <thead>
              <tr class="border-t border-gray-200">
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  <span class="lg:pl-2">Naam</span>
                </th>
                <th
                  class="px-6 py-3 text-xs font-medium leading-4 tracking-wider text-left text-gray-500 uppercase border-b border-gray-200 bg-gray-50">
                  <span class="lg:pl-2">Moeilijkheid</span>
                </th>
              </tr>
            </thead>
            <tbody class="bg-white divide-y divide-gray-100">
              <tr @click="open(template)" class="cursor-pointer hover:bg-gray-100" v-for="template in templates.data"
                :key="template.id">
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-900 whitespace-nowrap max-w-0">
                  <div class="flex items-center space-x-3 lg:pl-2">
                    <div class="flex-shrink-0 w-2.5 h-2.5 rounded-full bg-green-600"></div>
                    <a href="#" class="truncate hover:text-gray-600">
                      {{ template.name }}
                    </a>
                  </div>
                </td>
                <td class="px-6 py-3 text-sm font-medium leading-5 text-gray-500">
                  <div class="flex items-center space-x-2">
                    <span class="flex-shrink-0 text-xs font-medium leading-5">{{ template.difficulty }}</span>
                  </div>
                </td>
              </tr>
              <!-- More project rows... -->
            </tbody>
          </table>
        </div>
      </div>
      <Pagination :links="templates.links" :meta="templates.meta" class="" />
    </main>
  </layout>
</template>

<script>
import Layout from '@/Shared/Layout'
import Pagination from '../../Shared/Pagination.vue';

export default {
  props: {
    templates: Object
  },
  components: {
    Layout,
    Pagination
},
  data: () => ({
  }),
  methods: {
    open(template) {
      this.$inertia.get(template.links.show);
    },
    createTemplate() {
      this.$inertia.get('/templates/create');
    }
  }
}

</script>
